import {React, useEffect, useState, useRef} from 'react';
import '../App.css';
import './tree_trimming.css';
import './tree_removal.css';
import { Helmet } from "react-helmet";
import SlideInDiv from './slider.js'
import SlideInDivLeft from './slider2.js'
//import { GiWillowTree } from "react-icons/gi";
import UserModal from './UserModal.js';
import useHorizontalScroll from './useHorizontalScroll.js';
import { useScrollBehavior } from './useScrollBehavior.js';
//import Image1 from '../images/image1.jpg';
//import Image4 from '../images/image4.jpg';
//import Image5 from '../images/image5.jpg';
//import Image6 from '../images/image6.jpg';
//import Image7 from '../images/image7.jpg';
//import Image9 from '../images/image9.jpg';
//import Image10 from '../images/image10.jpg';
//import Image12 from '../images/image12.jpeg';
//import Image44 from '../images/image44.jpg';
//import Image45 from '../images/image45.jpg';
//import Image48 from '../images/image48.jpg';
//import Image52 from '../images/image52.jpg';
//import { TbShieldCheckFilled } from "react-icons/tb";
import { GiPalmTree } from "react-icons/gi";
//import { GiFruitTree } from "react-icons/gi";
//import { GiBirchTrees } from "react-icons/gi";
//import ExpandedImage from './ExpandedImage.js';
//import Collapsible from "./Collapsible.js";
//import Quest_video from '../images/SamsShort2.mp4';
import Mats from './mats.js'
import Testimonials from './testimonials.js'
import Gallery from './gallery.js'
import Faqs from './faqs.js'
import Footer from './footer4.js'



const Services2 = () => {

	useScrollBehavior();

      const [isVisibleLinks3, setIsVisibleLinks3] = useState(false);
      const [isVisibleText3, setIsVisibleText3] = useState(false);
	  const { scrollRef, scrollLeft, scrollRight } = useHorizontalScroll();
	  const [isVisibleImage2, setIsVisibleImage2] = useState(false);
	  const [expandedImage2, setExpandedImage2] = useState(null);
	  const imageRef2 = useRef(null);
      const linksRef3 = useRef(null);
      const textRef3 = useRef(null);
	  const [count, setCount] = useState(0);
	  const [percentage, setPercentage] = useState(0);
	  const [experience, setExperience] = useState(0); 
	  const ref = useRef(null);
	  const ref2 = useRef(null);
	  const ref3 = useRef(null);
	  const stickyRef2 = useRef(null);
	  const overlayRef2 = useRef(null);
	  const [isModalOpen, setIsModalOpen] = useState(false);
	  const openModal = () => setIsModalOpen(true);
	  const closeModal = () => setIsModalOpen(false);

      const handleScroll4 = () => {
            if (linksRef3.current) {
              const linksRect3 = linksRef3.current.getBoundingClientRect();
              const triggerOffsetLinks3 = 100;
              const triggerPointLinks3 = window.innerHeight - triggerOffsetLinks3;
              const isAboveTriggerPointLinks3 = linksRect3.top < triggerPointLinks3;
              setIsVisibleLinks3(isAboveTriggerPointLinks3);
            }
      
            if (textRef3.current) {
                  const textRect3 = textRef3.current.getBoundingClientRect();
                  const triggerOffsetText3 = 300; // Adjust this value for different trigger points
                  const triggerPointText3 = window.innerHeight - triggerOffsetText3;
                  const isAboveTriggerPointText3 = textRect3.top < triggerPointText3;
                  setIsVisibleText3(isAboveTriggerPointText3);
              }

			  if (imageRef2.current) {
				const imageRect2 = imageRef2.current.getBoundingClientRect();
				const triggerOffsetImage2 = 130; // Adjust this value for different trigger points
				const triggerPointImage2 = window.innerHeight - triggerOffsetImage2;
				const isAboveTriggerPointImage2 = imageRect2.top < triggerPointImage2;
				setIsVisibleImage2(isAboveTriggerPointImage2);
			  }

        };
      
        useEffect(() => {
            window.addEventListener('scroll', handleScroll4);
            handleScroll4(); // Check visibility on initial render
            return () => {
              window.removeEventListener('scroll', handleScroll4);
            };
        }, []);

            
            useEffect(() => {
                  const hash = window.location.hash.substring(1);
                  if (hash) {
                    const targetElement = document.getElementById(hash);
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
              }, []);

			  
	
	return (
		<>
		<Helmet>
  			<title>Tree Removal Service | Sam's Tree Service</title>
  			<meta name="description" content="Safe and efficient tree removal services in Sarasota, FL. Fully licensed and insured, we specialize in hazardous tree removals and stump grinding." />
			<link rel="canonical" href="https://samstreeservice.com/tree_removal" />
		</Helmet>


		<div id='main_serviceDiv2'>
            <div className="background-imageservice"></div>
            <div className="module_service" id="module_service1">
			<div id='service2_div1'>
				<div id='cover_service_div1'>
				<div id='service_title'>
							<h1>Tree removal</h1>
					</div>
				</div>
				</div>	
            </div>
            <div className="module_service" id="module_service2_removal">
					<div id='service_div3'>
					      <div id='slideCon3_2'>
							<SlideInDiv>
								<div id='slideInDive3_2'></div>	
							</SlideInDiv>
							<div id='container_Slide3_2'>
							<SlideInDivLeft>
								<div id='slideInDive2_3_2'></div>
							</SlideInDivLeft>
							<SlideInDivLeft>
								<div id='slideInDive3_3_2'></div>
							</SlideInDivLeft>	
							</div>
										
						</div>
				        <div id='removal_div4' ref={textRef3} className={`text_div_Link3 ${isVisibleLinks3  ? 'visible' : ''}`}>
							<div id='icon_two_half0_3removal'>
								<div id='two_half_text0_1_3removal'><h1> - - - - - -&nbsp;&nbsp;</h1>
								</div><div id='icon_two_half_icon0_3removal'><GiPalmTree /></div>
								<div id='two_half_text0_2_3removal'><h1>&nbsp;&nbsp;- - - - - -</h1></div>
							</div>
							<h1>Professional Tree Removal Services You Can Trust</h1>
							<p>At <strong>Sam's Tree Service</strong>, we understand 
							that tree removal is not just about cutting down a tree, 
							it's about ensuring the safety, aesthetics, and health 
							of your property. Whether it's a storm-damaged tree, 
							one that poses a safety risk, or simply part of a landscaping 
							project, we are your trusted tree removal specialists in  
							  <strong> Sarasota and Southwest Florida</strong> and our skilled team has 
							the expertise and equipment to handle the job efficiently 
							and safely.  Whether you need tree trimming and removal,
							 expert care from a tree surgeon, or a tree cutting estimate, 
							 our experienced tree service contractors are equipped to handle 
							 the job efficiently and safely.</p>
							
							<p>We offer affordable tree services in <srtong>Sarasota</srtong>, 
								providing expert solutions for hazardous, storm-damaged, 
								or unwanted trees. Our skilled tree doctors assess tree 
								health, ensuring your landscape remains both beautiful and 
								safe. From precision tree felling to thorough cleanup, we 
								take pride in delivering reliable tree felling service across <strong>Southwest 
								Florida</strong>.</p>
								<p>Contact <strong>Sam's Tree Service</strong> today for professional, 
									hassle-free tree care from <strong>Sarasota's</strong> trusted tree 
									specialists.

								
								<div id='booklink_removal1' 
  						            onClick={(e) => {
    						        e.preventDefault(); // Prevent the default link action
    						        openModal();
  						            }}>Get a Free Estimate!
					            </div>

								</p>
							
  								
							
						</div>
						{isModalOpen && <UserModal onClose={closeModal} />}
                        <UserModal isOpen={isModalOpen} onClose={closeModal} />
				</div>
				<div id='trimming_spacer_div3'>
				  <div id='trimming_divlink_container3' ref={linksRef3}>
					<div className={`trimming_spacer_div_Link3 ${isVisibleLinks3  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.3s' }}>
							
						<h1><i class="bi bi-houses" style={{ fontSize: '2rem', color: 'green'}}></i>&nbsp;Residential Services</h1>
						<p>We offer expert tree care for your home, including trimming, 
						   pruning, and safe tree removal. Our team ensures your trees 
						   remain healthy, enhancing your property's beauty and safety.</p>
					</div>
					<div className={`trimming_spacer_div_Link3 ${isVisibleLinks3  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.6s' }}>
						<h1><i className="bi bi-buildings" style={{ fontSize: '2rem', color: 'green' }}></i>&nbsp;Commercial</h1>
						<p>We provide safe, 
						   efficient, and budget-friendly tree removal services 
						   tailored to meet your commercial needs.</p>
					</div>
					<div className={`trimming_spacer_div_Link3 ${isVisibleLinks3  ? 'visible' : ''}`}
        				 style={{ transitionDelay: '.9s' }}>
					      <h1><i className="bi bi-exclamation-diamond"style={{ fontSize: '2rem', color: 'green' }} ></i>&nbsp;24/7 Emergency Services</h1>
						<p>Trust us anytime, day or night, for fast and dependable tree care, 
						   safeguarding your property and loved ones when it matters most.
						</p>
					</div>
					
				</div>
				</div>      
            </div>
			<div className="module_service" id="module_service2_5">
					
				<Mats/>

            </div>
            <div className="module_service" id="module_service3">

				<Testimonials/>
					
            </div>
            <div className="module_service" id="module_service4">
				<Gallery/>
            </div>
            <div className="module_service" id="module_service5">
				<Faqs/>
            </div>
            <Footer/>
		</div>
		</>
	);
};

export default Services2;

